import moment from "moment";

export const formatDate = (date?: string | null, format = "DD/MM/YYYY") => {
  if (!date || !moment(date).isValid()) return "N/A"; // or "" based on your needs
  return moment(date).format(format);
};
